<template>
  <div
    class="msg-image-text"
    v-if="!errorText"
  >
    <div class="image-text-layout6" v-if="layout == 6">
      <span>{{ jsonData.top.title }}</span>
      <em>{{ jsonData.top.summary_time }}</em>
      <a
        target="_blank"
        :href="jsonData.top.url"
        class="cover"
        :style="{ backgroundImage: 'url(' + jsonData.top.cover + ')' }"
      ></a>
      <strong>{{ jsonData.top.summary_content }}</strong>
      <a target="_blank" :href="jsonData.top.url" class="more">{{
        $t("common_read_all")
      }}</a>
    </div>
    <div class="image-text-layout5" v-if="layout == 5">
      <a
        target="_blank"
        :href="jsonData.top.url"
        class="cover"
        :style="{ backgroundImage: 'url(' + jsonData.top.cover + ')' }"
      >
        <span>{{ jsonData.top.title }}</span>
      </a>
      <a
        target="_blank"
        :href="item.url"
        class="layout4"
        v-for="(item, index) in jsonData.list"
        :key="index"
      >
        <span>{{ item.title }}</span>
        <em :style="{ backgroundImage: 'url(' + item.cover + ')' }"></em>
      </a>
    </div>
  </div>
  <div v-else>{{ errorText }}</div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { xml2json } from 'xml-js';
import { IMSDK, SDKUtils } from '@/imsdk/index.ts';
import axios from 'axios';
import { getScrollBottom, scrollLimit } from '@/utils/scroll.ts';
import globalWin from '@/utils/globalWin';

export default {
  props: {
    data: Object,
  },
  data() {
    return {
      jsonData: null,
      layout: 0,
      errorText: '',
    };
  },
  computed: {
  },
  async mounted() {
    if (!this.data.content && !this.data.path) {
      return;
    }
    if (!this.data.content) {
      try {
        if (this.data.compressed) {
          // 如果是SDK通路的被压缩的长文本
          this.data.content = await SDKUtils.downloadAndParseLongText(this.data, 'xml');
        } else {
          const resPath = await SDKUtils.getDownloadUrl(this.data, IMSDK.OBJTYPES.OBJ_LONGTEXT);
          if (resPath) {
            const response = await axios.get(resPath);
            if (response.status === 200) {
              this.data.content = response.data;
            }
          };
        }
      } catch (ex) {
        this.errorText = '获取消息内容异常';
      };
    };
    if (!this.data.content) {
      this.errorText = '获取消息内容异常';
      return;
    };
    let data = xml2json(this.data.content, {
      compact: true,
      ignoreDeclaration: true,
    });
    data = JSON.parse(data);
    const msg = (data && data.msg) || {};
    const items = msg.item || [];
    let layout = 0;
    const formatedDate = {
      top: {},
      list: [],
    };
    items.forEach
      && items.forEach((item) => {
        if (!item._attributes) return;
        const itemLayout = item._attributes.layout - 0;
        if (itemLayout === 5 || itemLayout === 6) {
          layout = itemLayout;
          formatedDate.top = {
            url: item._attributes.url || msg._attributes.url,
            title: item.title._text,
            cover: item.picture._attributes.cover,
            brief: msg._attributes.brief,
            summary_time: (item.summary && item.summary[0] && item.summary[0]._text) || '',
            summary_content: (item.summary && item.summary[1] && item.summary[1]._text) || '',
          };
        } else {
          formatedDate.list.push({
            url: item._attributes.url,
            title: item.title._text,
            cover: item.picture._attributes.cover,
          });
        }
      });
    layout && ((this.jsonData = formatedDate), (this.layout = layout));

    this.onLoad();
  },
  methods: {
    format(time) {
      const date = new Date(time);
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return [`${hours}:`, `${minutes}:`, seconds]
        .join('')
        .replace(/\b(\d)\b/g, '0$1');
    },

    // 数据加载后的滚动处理
    onLoad() {
      if (getScrollBottom() < scrollLimit) {
        globalWin.scrollToBottom(true, 500);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.msg-image-text {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 250px;
  text-align: left;
  .image-text-layout6 {
    border: 1px solid #dae4e9;
    border-radius: 4px;
    background-color: #fff;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      display: block;
      margin: 0 12px;
      line-height: 30px;
    }
    em {
      display: block;
      font-style: normal;
      font-size: 12px;
      margin: 0 12px 6px;
    }
    strong {
      display: block;
      font-weight: normal;
      overflow: hidden;
      line-height: 20px;
      font-size: 14px;
      margin: 4px 12px;
      overflow: hidden;
      max-height: 40px;
    }
    .more {
      border-top: 1px solid #dae4e9;
      margin: 0 12px;
      line-height: 30px;
      font-size: 12px;
      color: #1e2330;
      display: block;
      position: relative;
      &:after {
        content: "";
        width: 4px;
        height: 4px;
        border: 2px solid transparent;
        border-top-color: #a9bac7;
        border-right-color: #a9bac7;
        position: absolute;
        top: 11px;
        right: 1px;
        transform: rotate(45deg);
      }
      &:hover,
      &:active {
        opacity: 0.6;
      }
    }
  }
  .image-text-layout5 {
    overflow: hidden;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #dae4e9;
    .layout4 {
      display: flex;
      margin: 0 12px;
      padding: 15px 0;
      border-bottom: 1px solid #dae4e9;
      align-items: center;
      color: #1e2330;
      &:last-child {
        border: 0 none;
      }
      &:hover,
      &:active {
        span {
          opacity: 0.6;
        }
      }
      span {
        margin-right: 12px;
        font-size: 12px;
        line-height: 20px;
        overflow: hidden;
        max-height: 40px;
        flex: 1 1 auto;
        display: block;
      }
      em {
        width: 40px;
        height: 40px;
        background-size: cover;
        flex: 0 0 auto;
        display: block;
      }
    }
  }
  .cover {
    display: block;
    position: relative;
    width: 100%;
    padding-top: 52%;
    overflow: hidden;
    background-position: center;
    background-size: cover;
    span {
      position: absolute;
      left: 0;
      bottom: 0;
      line-height: 42px;
      padding: 0 12px;
      width: 100%;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.78);
      font-size: 14px;
      color: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
